<ng-container *transloco="let t">
  @if (!loading) {
    <div class="flex w-[25rem] flex-col gap-4">
      <IInput
        [value]="name"
        (valueChange)="name = $event"
        placeholder="{{ t('new-account-group-popup.give_name_placeholder') }}"
        [label]="t('common.name')"
        [maxLength]="200"
      />

      <div class="flex justify-end gap-2">
        <IButton [label]="t('common.cancel')" color="white" (onClick)="modalRef.close()" />
        <IButton [label]="t('common.create')" (onClick)="create()" [disabled]="name.trim().length === 0" />
      </div>
    </div>
  }
  <app-spinner [display]="loading"></app-spinner>
</ng-container>
